<template minapp='mpx' xlang='wxml'>
  <view class='es-card custom-class' bindtap="handleClick">
    <block wx:if="{{scoped.header}}">
      <view class='es-card__header custom-header'>
        <slot name='header' />
      </view>
    </block>

    <view class='es-card__body custom-body'>
      <slot />
    </view>

    <block wx:if="{{scoped.footer}}">
      <view  class='es-card__footer custom-footer'>
        <slot name='footer' />
      </view>
    </block>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    classes: ['custom-header', 'custom-body', 'custom-footer', 'custom-class'],
    props: {
      layout: {
        type: Array,
        value: []
      }
    },

    computed: {
      scoped() {
        return ['header', 'footer'].reduce((slot, name) => {
          slot[name] = this.layout.includes(name)
          return slot
        }, {})
      }
    },

    methods: {
      handleClick() {
        this.$trigger('click')
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>

